module.exports = __webpack_public_path__ + "img/ai.a85571e0.jpg";